import styled from "styled-components";

export const Container = styled.div`
    box-sizing: border-box;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    padding: clamp(24px, 6vh, 48px) clamp(12px, 4vw, 16px);
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
`
